import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingContext from '@/custom/context/setting/settingContext'
import { useFormik } from 'formik'
import * as Yup from 'yup'

const Configurations = () => {
    const settingcontext = useContext(SettingContext)

    const initialValues = {
        page: 1,
        limit: 1,
        primaryTable: 'auction_end_time_configuration',
        orderby: '',
        filters: true,
    }
    const {
        searchTableFetch,
        searchTableAction,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext
    const formikConfig = useFormik({
        initialValues: {
            id: 1,
            status: 1,
            auction_end_time_spacing_minutes: '',
            auction_duration_hours: '',
            mon_start_time: '',
            mon_end_time: '',
            tue_start_time: '',
            tue_end_time: '',
            wed_start_time: '',
            wed_end_time: '',
            thu_start_time: '',
            thu_end_time: '',
            fri_start_time: '',
            fri_end_time: '',
            sat_start_time: '',
            sat_end_time: '',
            sun_start_time: '',
            sun_end_time: '',
        },
        validationSchema: null,
        onSubmit: (values) => {
            values.table = 'auction_end_time_configuration'
            values.auctionConfig = true
            searchTableAction(values, false, 'auction_config')
        },
    })

    const formikSiteConfig = useFormik({
        initialValues: {
            id: 1,
            restriction_new_compare: '',
            restriction_old_compare: '',
            listing_price_restriction: '',
            relisting_start_price_percentage_restriction: '',
            relisting_start_price_percentage_restriction: '',
            relisting_price_restriction: '',
            un_image: '',
        },
        validationSchema: null,
        onSubmit: (values) => {
            values.table = 'auction_end_time_configuration'
            values.auctionConfig = true
            searchTableAction(values, false, 'auction_config')
        },
    })

    useEffect(() => {
        if (responseStatusSetting) {
            if (
                responseStatusSetting.from === 'auction_config' &&
                responseStatusSetting.status === 'success'
            ) {
                searchTableFetch(initialValues, 'auction_config_fetch')
            }
        }
    }, [responseStatusSetting])

    useEffect(() => {
        searchTableFetch(initialValues, 'auction_config_fetch')
    }, [])

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'auction_config_fetch') {
                formikConfig.setValues({
                    ...search_fetch_data.records[0], // Set values from records[0]
                    status: 1, // Set default status to 1
                })
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'auction_config_fetch') {
                formikSiteConfig.setValues({
                    ...search_fetch_data.records[0], // Set values from records[0]
                })
            }
        }
    }, [search_fetch_data])

    const confiFields = [
        {
            label: 'Auction End Time Spacing(Minutes)',
            name: 'auction_end_time_spacing_minutes',
            type: 'number',
            class: 'col-6',
            placeholder: 'Auction End Time Spacing(Minutes)',
        },
        {
            label: 'Auction Duration(hours)',
            name: 'auction_duration_hours',
            type: 'number',
            class: 'col-6',
            placeholder: 'Auction Duration(hours)',
        },
        {
            label: 'Monday Start Time',
            name: 'mon_start_time',
            type: 'number',
            class: 'col-3',
            placeholder: 'Monday Start Time',
        },
        {
            label: 'Monday End Time',
            name: 'mon_end_time',
            type: 'number',
            class: 'col-3',
            placeholder: 'Monday End Time',
        },
        {
            label: 'Tuesday Start Time',
            name: 'tue_start_time',
            type: 'number',
            class: 'col-3',
            placeholder: 'Tuesday Start Time',
        },
        {
            label: 'Tuesday End Time',
            name: 'tue_end_time',
            type: 'number',
            class: 'col-3',
            placeholder: 'Tuesday End Time',
        },
        {
            label: 'Wednesday Start Time',
            name: 'wed_start_time',
            type: 'number',
            class: 'col-3',
            placeholder: 'Wednesday Start Time',
        },
        {
            label: 'Wednesday End Time',
            name: 'wed_end_time',
            type: 'number',
            class: 'col-3',
            placeholder: 'Wednesday End Time',
        },
        {
            label: 'Thursday Start Time',
            name: 'thu_start_time',
            type: 'number',
            class: 'col-3',
            placeholder: 'Thursday Start Time',
        },
        {
            label: 'Thursday End Time',
            name: 'thu_end_time',
            type: 'number',
            class: 'col-3',
            placeholder: 'Thursday End Time',
        },
        {
            label: 'Friday Start Time',
            name: 'fri_start_time',
            type: 'number',
            class: 'col-3',
            placeholder: 'Friday Start Time',
        },
        {
            label: 'Friday End Time',
            name: 'fri_end_time',
            type: 'number',
            class: 'col-3',
            placeholder: 'Friday End Time',
        },
        {
            label: 'Saturday Start Time',
            name: 'sat_start_time',
            type: 'number',
            class: 'col-3',
            placeholder: 'Saturday Start Time',
        },
        {
            label: 'Saturday End Time',
            name: 'sat_end_time',
            type: 'number',
            class: 'col-3',
            placeholder: 'Saturday End Time',
        },
        {
            label: 'Sunday Start Time',
            name: 'sun_start_time',
            type: 'number',
            class: 'col-3',
            placeholder: 'Sunday Start Time',
        },
        {
            label: 'Sunday End Time',
            name: 'sun_end_time',
            type: 'number',
            class: 'col-3',
            placeholder: 'Sunday End Time',
        },
    ]

    const confiFields1 = [
        {
            label: 'Percentage Restriction for new comparison',
            name: 'restriction_new_compare',
            type: 'number',
            class: 'col-6',
            placeholder: 'Percentage Restriction for new comparison',
        },
        {
            label: 'Percentage Restriction for Older Comparison',
            name: 'restriction_old_compare',
            type: 'number',
            class: 'col-6',
            placeholder: ' Percentage Restriction for Older Comparison',
        },
        {
            label: 'Listing Price Restriction',
            name: 'listing_price_restriction',
            type: 'number',
            class: 'col-6',
            placeholder: 'Listing Price Restriction',
        },
        {
            label: 'Relisting Start Price Percentage Restriction (%)',
            name: 'relisting_start_price_percentage_restriction',
            type: 'number',
            class: 'col-6',
            placeholder: 'Relisting Start Price Percentage Restriction (%)',
        },
        {
            label: 'Relisting Reserve Price Percentage Restriction (%)',
            name: 'relisting_reserve_price_percentage_restriction',
            type: 'number',
            class: 'col-6',
            placeholder: 'Relisting Reserve Price Percentage Restriction (%)',
        },
        {
            label: 'Relisting Price Restriction',
            name: 'relisting_price_restriction',
            type: 'number',
            class: 'col-6',
            placeholder: 'Relisting Price Restriction',
        },
        {
            label: 'UV Image checking { 1:on , 2:off }',
            name: 'uv_image',
            type: 'number',
            class: 'col-6',
            placeholder: 'UV Image checking { 1:on , 2:off }',
        },
    ]

    return (
        <Layout>
            <div className="dashboard">
                <div>
                    <h4 className="settingsHead">Site Configuration</h4>
                    <form onSubmit={formikSiteConfig.handleSubmit}>
                        <div className="row">
                            {confiFields1?.map((field, index) => (
                                <div key={index} className={field.class}>
                                    <CustomInput
                                        label={field.label}
                                        name={field.name}
                                        type={field.type}
                                        placeholder={field.placeholder}
                                        value={
                                            formikSiteConfig.values[field.name]
                                        }
                                        onChange={formikSiteConfig.handleChange}
                                        formikSiteConfig
                                        error={
                                            formikSiteConfig.touched[
                                                field.name
                                            ] &&
                                            formikSiteConfig.errors[field.name]
                                        }
                                    />
                                </div>
                            ))}
                        </div>
                        <PrimaryButton
                            id="general_save"
                            label="Update"
                            type="submit"
                        />
                    </form>
                </div>
                <div>
                    <h4 className="settingsHead">
                        Auction End Times Configuration
                    </h4>
                    <form onSubmit={formikConfig.handleSubmit}>
                        <div className="row">
                            {confiFields.map((field, index) => (
                                <div key={index} className={field.class}>
                                    <CustomInput
                                        label={field.label}
                                        name={field.name}
                                        type={field.type}
                                        placeholder={field.placeholder}
                                        value={formikConfig.values[field.name]}
                                        onChange={formikConfig.handleChange}
                                        onBlur={formikConfig.handleBlur}
                                        error={
                                            formikConfig.touched[field.name] &&
                                            formikConfig.errors[field.name]
                                        }
                                    />
                                </div>
                            ))}
                        </div>
                        <PrimaryButton
                            id="general_save"
                            label="Update"
                            type="submit"
                        />
                    </form>
                </div>
            </div>
        </Layout>
    )
}

export default Configurations
